var _path, _path2, _path3, _path4;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgContacts = function SvgContacts(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6341 7.22627C18.8195 7.22627 19.7805 6.26688 19.7805 5.08341C19.7805 3.89994 18.8195 2.94055 17.6341 2.94055C16.4487 2.94055 15.4878 3.89994 15.4878 5.08341C15.4878 6.26688 16.4487 7.22627 17.6341 7.22627Z",
    stroke: "#0258FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6341 10.4406C15.3368 10.4406 12.7583 11.8347 12.5366 12.3156C12.3549 12.7096 12.2683 13.9227 12.2683 13.9227C12.2683 14.3656 12.628 14.7263 13.0716 14.7263H22.1967C22.6403 14.7263 23 14.3656 23 13.9227C23 13.9227 22.9134 12.7096 22.7317 12.3156C22.51 11.8347 19.9315 10.4406 17.6341 10.4406V10.4406Z",
    stroke: "#0258FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.51223 7.10273C10.108 7.10273 11.4015 5.81124 11.4015 4.21811C11.4015 2.62498 10.108 1.3335 8.51223 1.3335C6.91651 1.3335 5.62292 2.62498 5.62292 4.21811C5.62292 5.81124 6.91651 7.10273 8.51223 7.10273Z",
    stroke: "#082344",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5122 10.5643C5.2959 10.5643 1.68602 12.4411 1.37561 13.0884C1.12123 13.6188 1 15.2518 1 15.2518C1 15.848 1.50352 16.3336 2.12465 16.3336H14.8997C15.5209 16.3336 16.0244 15.848 16.0244 15.2518C16.0244 15.2518 15.9032 13.6188 15.6488 13.0884C15.3384 12.4411 11.7285 10.5643 8.5122 10.5643Z",
    fill: "white",
    stroke: "#082344",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgContacts, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/contacts.c4bac821.svg";
export { ForwardRef as ReactComponent };